import {
  getAreaList
} from "@/utils/area";
/**
 * 获取字典数据
 * @param {String} type 字典类型
 */
export const getDictData = {
  methods: {
    async getDictData() {
      let obj = {
        dictType: "sys_mechanism_location",
        kyLang: this.$store.getters.language
      }
      const res = await this.$api.getDictData(obj);
      let options = [];
      if (res.code == 200) {
        options = res.data.map(({
          dictLabel,
          dictValue
        }) => ({
          dictLabel,
          dictValue,
        }));
      }
      return options;
    },
    async getDictDatasex() {
      let obj = {
        dictType: "sys_user_sex",
        kyLang: this.$store.getters.language
      }
      const res = await this.$api.getDictData(obj);
      let options = [];
      if (res.code == 200) {
        options = res.data.map(({
          dictLabel,
          dictValue
        }) => ({
          dictLabel,
          dictValue,
        }));
      }
      return options;
    },
  },
};
import {
  regionData
} from "element-china-area-data";
/**
 * 加载省市区
 */
export const loadProvinceListMixin = {
  data() {
    return {
      areaMixin: [],
    };
  },
  methods: {
    async loadProvinceList(...params) {
      // 使用组件库中的省市区数据
      // this.areaMixin = regionData;
      // 使用接口的省市区数据
      const res = await this.$api.getProvinceListApi(...params);
      // 临时处理省市区加载慢的问题
      // const res = getAreaList()
      // console.log({ res });
      const area = res.data.map((item) => {
        const data = {
          id: item.id,
          label: item.label,
          value: item.value,
          children: [],
        };
        data.children = item.children.map((val) => {
          const data = {
            id: val.id,
            label: val.label,
            value: val.value,
            children: [],
          };
          data.children = val.children.map((abc) => ({
            id: abc.id,
            label: abc.label,
            value: abc.value,
          }));
          return data;
        });
        return data;
      });
      this.areaMixin = area;
    },
  },
};
// 全局混入
// 游客模式
import {
  MessageBox
} from "element-ui";
export const touristMixin = {
  methods: {
    isHaveToken() {
      // 兼容游客模式
      return !this.$tools.isTourist();
    },
    isTourist() {
      // 游客模式
      if (this.$tools.isTourist()) {
        MessageBox.confirm("您暂未登录，请先登录", {
          confirmButtonText: "去登录",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$store.dispatch("resetToken").then(() => {
            this.$router.push("/login");
          });
        }).catch(() => {});
        return true;
      }
      return false;
    },
  },
};